import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContentEditableDirective } from './contenteditable.directive';
import { DraggableDirective } from './draggable.directive';
import { OutsideClickDirective } from './outside-click.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ContentEditableDirective, DraggableDirective, OutsideClickDirective],
  exports: [ContentEditableDirective, DraggableDirective, OutsideClickDirective],
  })
export class DirectivesModule { }
